import styled from 'styled-components'
import Icon from '@mdi/react'

import theme from 'theme_'
import { StyledCommonLinkButton } from 'components/Button/styles'

export const StyledDownloadButton = styled(StyledCommonLinkButton)`
  color: ${theme.colors.horizonOrange};
  transition: color 0.2s ease;
  :disabled,
  [disabled] {
    color: ${theme.colors.beachGrey};
    cursor: default;
  }
`

export const DownloadIcon = styled(Icon)`
  :hover {
    opacity: 0.8;
  }
`

export const ErrorIcon = styled(DownloadIcon)`
  color: ${theme.colors.horizonOrange};
  cursor: default;
  :hover {
    opacity: 1;
  }
`

export const DownloadIconWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.xs};
`
